import {
  getCompletionGroupByOptions,
  getFormTypeOptions,
} from 'components/GenerateReportForm/utils/getFormFields';
import { FieldNames } from 'components/GenerateReportForm/types';
import { Values } from '@lib/interfaces/form';

type Args = {
  defaultPeriod: string[];
};

export default function useDefaultValues(args: Args): Values {
  const { defaultPeriod } = args;
  return {
    [FieldNames.FormType]: getFormTypeOptions()?.[0],
    [FieldNames.Period]: defaultPeriod,
    [FieldNames.CompletionGroupBy]: getCompletionGroupByOptions()?.[0],
    [FieldNames.RecipientIds]: [],
    [FieldNames.Message]: null,
    // Custom renders
    [FieldNames.Title1]: null,
    [FieldNames.Title2]: null,
    [FieldNames.Title3]: null,
    [FieldNames.ReportDetails]: null,
  };
}
